
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/internal",
      function () {
        return require("private-next-pages/internal/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/internal"])
      });
    }
  